<script setup lang="ts">
import { RouterView } from 'vue-router';
</script>

<template>
  <header>
    <div class="wrapper">
      <a href="https://www.aerlingus.com/">
        <span class="logo"></span>
      </a>
    </div>
  </header>

  <RouterView />

  <footer>
    <div class="wrapper">
      <span class="copyright" i18n="common.text.copyright"
        >Copyright © Aer Lingus Group DAC and Aer Lingus Ltd. All rights
        reserved</span
      >
      <a
        target="_blank"
        style="float: right"
        href="https://www.aerlingus.com/support/legal/privacy-statement/"
        >Privacy</a
      >
    </div>
  </footer>
</template>

<style scoped>
.logo {
  display: block;
  width: 197px;
  height: 37px;
  background: url(/images/eiLogo_Teal.svg) no-repeat top left;
  background-size: 197px 37px;
}

header {
  border-bottom: 1px solid #d0d0ce;
  padding: 24px 0 27px 0;
}
footer {
  background: var(--cloud-white);
  border-top: 1px solid var(--cool-grey-1);
  padding: 36px 40px;
  margin-top: 32px;
}

.copyright {
  font-size: 0.875rem;
  color: var(--cool-grey-10);
}
</style>
